import React from "react";
import styles from "./_project.module.sass";
import Link from "next/link";
import Header from "../../components/Header";
import Image from "next/image";
import { useRouter } from "next/router";
import macImg from '../../public/images/decor/mac.webp'
import mac2Img from '../../public/images/decor/mac2.webp'
import Head from "next/head";

import wordbankMock from '../../public/images/wordbank/mock.webp'
import uplyftMock from '../../public/images/uplyft/mock.webp'
import pencylMock from '../../public/images/pencyl/mock.webp'

import wordbankDecor from '../../public/images/wordbank/decor.webp'
import uplyftDecor from '../../public/images/uplyft/decor.webp'
import pencylDecor from '../../public/images/pencyl/decor.webp'

import github from '../../public/images/icons/github2.webp'
import link from '../../public/images/icons/link.webp'

import Footer from '../../components/Footer'

const projectInfo = {
    wordbank: {
        title:"Wordbank",
        mock: wordbankMock,
        decor: wordbankDecor,
        summary:"Using Firebase and Next.js, I developed WordBank, a mobile-first web app that helps language learners improve their vocabulary.",
        github:"https://github.com/zaynvirkk/Wordbank",
        link:"https://wordbank.vercel.app",
        client:"WordBank: A mobile-first next.js app that helps you improve your vocabulary with personalized exercises, custom word collections, and progress tracking. Perfect for language learners seeking to expand their lexicon anytime, anywhere. WordBank is a comprehensive language-learning tool that delivers a seamless user experience.",
        date:"Oct, 2022 - Mar 2023",
        role:"Full Stack Development",
        technology:"Next.j, React.js, HTML5, CSS3, SASS, Stripe, Firebase, and JavaScript",
        screenshots:24,
        portraitScreenshotsAfter: 10,
        next:"uplyft",
        nextImg: uplyftMock
    },
    uplyft: {
        title:"Uplyft",
        mock: uplyftMock,
        decor: uplyftDecor,
        summary:"Developed this full-stack project, handling UI design, UX design, front-end, and back-end development.",
        github:"https://github.com/zaynvirkk/Uplyft",
        link:"https://skyhance.vercel.app",
        client:"Uplyft is a collection of multiple apps, each designed to help you conquer specific challenges in life.",
        date:"Sep, 2021 - Mar 2022",
        role:"Full Stack Development",
        technology:"React.js, HTML5, CSS3, SASS, Stripe, Firebase, and JavaScript",
        screenshots:15,
        next:"pencyl",
        nextImg: pencylMock
    },
    pencyl: {
        title:"Pencyl",
        mock: pencylMock,
        decor: pencylDecor,
        summary:"Designed and developed a platform for creating and generating NFTs from beginning to end.",
        github:"https://github.com/zaynvirkk/Pencyl",
        link:"https://pencyl.vercel.app/",
        client:"Pencyl is a tool designed to make the proccess of designing and generating NFTs as easy as possible",
        date:"Mar, 2022 - May 2022",
        role:"Full Stack Development",
        technology:"React.js, HTML5, SASS, Firebase, and JavaScript",
        screenshots:6,
        next:"wordbank",
        nextImg: wordbankMock
    }
}

const Project = React.memo(() => {
    
    const router = useRouter()
    const {project} = router.query
    const props = projectInfo[project]

    if(props){
        return (
            <React.Fragment>
                <Head>
                    <title>{`Zayn Virk | ${props.title.charAt(0).toUpperCase()+props.title.slice(1)} | ${props.summary}`}</title>
                    <meta name="description" content={props.client} />
                </Head>
                <div className={styles.project}>
                    <Header links={["Info", "Screenshots", "Next Project"]} />
                    <div className={styles.title}>
                        <div className={styles.heroImg}>
                            <div className={styles.macImg}><Image placeholder="blur" src={macImg} sizes="(max-width: 600px) 70vw, 35vw" fill="true" alt="" priority /></div>
                            <div className={styles.demoImg}><Image placeholder="blur" src={props.mock} sizes="(max-width: 600px) 70vw, 35vw" fill="true" alt="" priority /></div>
                        </div>
                        <article>
                            <h1>{props.title}</h1>
                            <h2>{props.summary}</h2>
                            <div className={styles.projectLinks}>
                                <a href={props.github}>
                                    <div className={styles.content}>
                                        <div className={styles.img}>
                                            <Image loading="lazy" src={github} placeholder="blur" sizes="(max-width: 1200px) 36px, 3vw" fill="true" alt="Github" />
                                        </div>
                                        <div className={styles.text}>Github</div>
                                    </div>
                                </a>
                                <a href={props.link} className={styles.gradientBox}>
                                    <div className={styles.content}>
                                        <div className={styles.img}>
                                            <Image loading="lazy" src={link} placeholder="blur" sizes="(max-width: 1200px) 36px, 3vw" fill="true" alt="Github" />
                                        </div>
                                        <div className={styles.text}>Demo</div>
                                    </div>
                                    <div className={styles.background} />
                                </a>
                            </div>
                        </article>
                    </div>

                    <div className={styles.projectLinks}>
                        <a href={props.github}>
                            <div className={styles.content}>
                                <div className={styles.img}>
                                    <Image loading="lazy" src={github} placeholder="blur" sizes="(max-width: 1200px) 36px, 3vw" fill="true" alt="Github" />
                                </div>
                                <div className={styles.text}>Github</div>
                            </div>
                        </a>
                        <a href={props.link} className={styles.gradientBox}>
                            <div className={styles.content}>
                                <div className={styles.img}>
                                    <Image loading="lazy" src={link} placeholder="blur" sizes="(max-width: 1200px) 36px, 3vw" fill="true" alt="Github" />
                                </div>
                                <div className={styles.text}>Demo</div>
                            </div>
                            <div className={styles.background} />
                        </a>
                    </div>

                    <section className={styles.infoGrid}>
                    <ul>
                        <li>
                            <div className={styles.emoji}>💼</div>
                            <div className={styles.content}>
                                <h3>Client</h3>
                                <p>{props.client}</p>
                            </div>
                        </li>
                        <li>
                            <div className={styles.emoji}>📆</div>
                            <div className={styles.content}>
                                <h3>Date</h3>
                                <p>{props.date}</p>
                            </div>
                        </li>
                        <li>
                            <div className={styles.emoji}>🔑</div>
                            <div className={styles.content}>
                                <h3>Role</h3>
                                <p>{props.role}</p>
                            </div>
                        </li>
                        <li>
                            <div className={styles.emoji}>💻</div>
                            <div className={styles.content}>
                                <h3>Technology</h3>
                                <p>{props.technology}</p>
                            </div>
                        </li>
                        <li>
                        <div className={styles.decorImg}><Image loading="lazy" src={props.decor} placeholder="blur" sizes="20vw" fill="true" alt="" /></div>
                        </li>
                    </ul>
                    </section>

                    <section className={styles.screenshots} id="shots">
                    {Array.apply(null, {length: props.screenshots}).map((_, i)=>{
                        if(props.portraitScreenshotsAfter){
                            if(i+1 < props.portraitScreenshotsAfter){
                                return <div key={i} className={styles.screenshot}><Image alt='' src={require(`../../public/images/${props.title.toLowerCase()}/${i+1}.webp`)} placeholder="blur" sizes="(max-width: 600px) 80vw, (max-width: 1200px) 35vw, 30vw" fill="true" /></div>
                            }else{
                                return <div key={i} className={`${styles.screenshot} ${styles.portraitScreenshot}`}><Image alt='' src={require(`../../public/images/${props.title.toLowerCase()}/${i+1}.webp`)} placeholder="blur" sizes="(max-width: 600px) 80vw, (max-width: 1200px) 35vw, 30vw" fill="true" /></div>
                            }
                        }else{
                            return <div key={i} className={styles.screenshot}><Image alt='' src={require(`../../public/images/${props.title.toLowerCase()}/${i+1}.webp`)} placeholder="blur" sizes="(max-width: 600px) 80vw, (max-width: 1200px) 35vw, 30vw" fill="true" /></div>
                        }
                    })}
                    </section>

                    <section className={styles.viewMore}>
                    <Link className={styles.nextBtn} shallow={true} prefetch={false} scroll={true} href={`/projects/${props.next}`}>
                        <span>Next Project</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                        </svg>
                    </Link>
                    <div className={styles.nextImg}>
                        <div className={styles.macImg}><Image loading="lazy" src={mac2Img} placeholder="blur" sizes="(max-width: 600px) 45vw, 40vw" alt="" fill="true" /></div>
                        <div className={styles.demoImg2}>
                        <Image
                            loading="lazy"
                            src={props.nextImg}
                            placeholder="blur"
                            sizes="(max-width: 600px) 50vw, (max-width: 820px) 45vw, 40vw"
                            alt=""
                            fill="true"
                        />
                        </div>
                    </div>
                    </section>
                </div>
                <Footer />
            </React.Fragment>
        )
    }else{
        return null
    }
    
})

export default Project;